var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Poll"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Poll",
    clipPath: "url(#clip-Poll)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1424",
    "data-name": "Group 1424",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M33.573,43.395l-5.409-5.409H14a5,5,0,0,1-5-5V15a5,5,0,0,1,5-5H39.984a5,5,0,0,1,5,5V32.988a5,5,0,0,1-5,5h-3v4a2,2,0,0,1-3.412,1.413Z",
    transform: "translate(-0.003 -0.003)",
    fill: "#0ca0f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M41.983,26.991V10.424a4.964,4.964,0,0,0-2-.424H14a5,5,0,0,0-5,5V32.988a5,5,0,0,0,5,5h4.066l3-3H33.987A8.005,8.005,0,0,0,41.983,26.991Z",
    transform: "translate(-0.003 -0.003)",
    fill: "#0588e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M13,37.982a1.993,1.993,0,0,1-2-2v-4H8a5,5,0,0,1-5-5V9A5,5,0,0,1,8,4H33.984a5,5,0,0,1,5,5V26.988a5,5,0,0,1-5,5H19.817l-5.409,5.409A2,2,0,0,1,13,37.982Z",
    transform: "translate(0)",
    fill: "#47caf0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1423",
    "data-name": "Group 1423",
    transform: "translate(16.533 9.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M21,21.994a1,1,0,0,1-1-1v-.77a4.047,4.047,0,0,1,2.207-3.534A2.528,2.528,0,0,0,23.431,13.9a2.5,2.5,0,0,0-4.9.243,1,1,0,0,1-1.98-.284,4.5,4.5,0,1,1,6.622,4.585A2.083,2.083,0,0,0,22,20.225v.77A1,1,0,0,1,21,21.994Z",
    transform: "translate(-16.54 -9.996)",
    fill: "#eff3f9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_494",
    "data-name": "Ellipse 494",
    cx: 0.945,
    cy: 0.818,
    rx: 0.945,
    ry: 0.818,
    transform: "translate(3.533 13.634)",
    fill: "#eff3f9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/Poll.7fb4e943.svg";
export { ForwardRef as ReactComponent };